import { cn } from '@/lib/utils';

interface SegmentedProps<T extends string> {
  value: T;
  onChange: (value: T) => void;
  options: { value: T; label: string }[];
  'aria-label': string;
  className?: string;
}

/** Radio-group styled as a segmented control (used where tabs have no panels of their own). */
export function Segmented<T extends string>({
  value,
  onChange,
  options,
  className,
  ...aria
}: SegmentedProps<T>) {
  return (
    <div
      role="radiogroup"
      aria-label={aria['aria-label']}
      className={cn('inline-flex rounded-lg bg-muted p-1 text-sm', className)}
    >
      {options.map((o) => (
        <button
          key={o.value}
          type="button"
          role="radio"
          aria-checked={value === o.value}
          onClick={() => onChange(o.value)}
          onKeyDown={(e) => {
            const idx = options.findIndex((x) => x.value === value);
            if (e.key === 'ArrowRight' || e.key === 'ArrowDown')
              onChange(options[(idx + 1) % options.length]!.value);
            if (e.key === 'ArrowLeft' || e.key === 'ArrowUp')
              onChange(options[(idx - 1 + options.length) % options.length]!.value);
          }}
          className={cn(
            'rounded-md px-3 py-1 font-medium',
            value === o.value
              ? 'bg-background shadow'
              : 'text-muted-foreground hover:text-foreground',
          )}
        >
          {o.label}
        </button>
      ))}
    </div>
  );
}
